import Link from '@mui/material/Link';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import { GridActionsCellItemProps } from '@mui/x-data-grid-pro';
import { HTMLAttributeAnchorTarget, ReactNode, RefObject } from 'react';

interface LinkActionItemProps
	extends Pick<GridActionsCellItemProps, 'showInMenu' | 'label'> {
	href: string;
	label: string;
	startIcon: ReactNode;
	target?: HTMLAttributeAnchorTarget;
	ref?: RefObject<HTMLLIElement | null>;
}
export const LinkActionItem = ({
	href,
	label,
	target,
	startIcon,
	ref,
}: LinkActionItemProps) => (
	<MenuItem ref={ref} sx={{ padding: 0 }}>
		<Link
			underline="hover"
			href={href}
			target={target}
			sx={{
				flex: '1 1 auto',
				display: 'flex',
				alignItems: 'center',
				padding: (theme) => theme.spacing(0.75, 2),
			}}>
			<ListItemIcon>{startIcon}</ListItemIcon>
			<ListItemText>{label}</ListItemText>
		</Link>
	</MenuItem>
);

LinkActionItem.displayName = 'LinkActionItem';
